import { render, staticRenderFns } from "./RzjCardRecord.vue?vue&type=template&id=0c5f179f&scoped=true"
import script from "./RzjCardRecord.vue?vue&type=script&lang=js"
export * from "./RzjCardRecord.vue?vue&type=script&lang=js"
import style0 from "./RzjCardRecord.vue?vue&type=style&index=0&id=0c5f179f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f179f",
  null
  
)

export default component.exports